
import { defineComponent, PropType } from 'vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import DriveMenuPopUp from '@/modules/drive/components/UI/DriveMenuPopUp.vue';
import { IFolder } from '@/types/interfaces';

export default defineComponent({
  components: {
    BottomPopUpItem,
    DriveMenuPopUp,
  },
  props: {
    folder: { type: Object as PropType<IFolder>, required: true },
    disableMove: { type: Boolean, default: false },
    disableShare: { type: Boolean, default: false },
    positionData: { type: Object, required: true },
  },
  emits: [
    'close',
    'openMovePopUp',
    'deleteFolder',
    'renameFolder',
    'shareFolder',
    'openInfoPopUp',
    'saveFolderAsCopy',
  ],
  setup(props, { emit }) {
    function hidePopUp() {
      emit('close');
    }

    function shareFolder() {
      emit('shareFolder');
    }

    function renameFolder() {
      emit('renameFolder');
    }

    function openMovePopUp() {
      emit('openMovePopUp');
    }

    function deleteFolder() {
      emit('deleteFolder');
    }

    function openInfoPopUp() {
      emit('openInfoPopUp');
    }

    function saveFolderAsCopy() {
      emit('saveFolderAsCopy');
    }

    return {
      renameFolder,
      deleteFolder,
      hidePopUp,
      openMovePopUp,
      shareFolder,
      openInfoPopUp,
      saveFolderAsCopy,
    };
  },
});
